const newHandleAddGiftAndReload = async (ruleId) => { 
        window.tlAdvancedFreeGift.loadingWhenClaim();
        const res = await window.tlAdvancedFreeGift.handleAddGift([ruleId]);

        if(res.status !== 200){
            const resJson = await res.json();
            window.tlAdvancedFreeGift.showError(ruleId, resJson.description);
            window.tlAdvancedFreeGift.removeLoading();
            return;
        }
        if(!window.TLCustomEventGiftsAdvanced){
          window.tlAdvancedFreeGift.updateCartData();
          const cartItemEl = document.querySelector('cart-items')
          fetch(`${routes.cart_url}?section_id=main-cart-items`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('cart-items');
            if(cartItemEl){
              cartItemEl.innerHTML = sourceQty.innerHTML;     
            }
          })
          .catch((e) => {
            console.error(e);
          });
        } else if (window.TLCustomEventGiftsAdvanced == 1) {
            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-handleAddGiftAndReload"));
        }
    }
const intervalId2 = setInterval(() => {
  if(window.tlAdvancedFreeGift){
    
    clearInterval(intervalId2);
    window.tlAdvancedFreeGift.handleAddGiftAndReload = newHandleAddGiftAndReload
  
    
    
  }
}, 10);

setTimeout(() => {
  clearInterval(intervalId2);
}, 5000);